const EligibilityFaqContentSF = [
  {
    title: 'What is required from me to be able to drive with Autzu?',
    info: [
      {
        text: {
          plaintext: 'You must be 21+ years of age'
        }
      },
      {
        text: {
          plaintext: 'Have a valid in-state driver’s license'
        }
      },
      {
        text: {
          plaintext:
            'Have an active rideshare driver account (such as Uber Driver) '
        }
      }
    ]
  },
  {
    title: 'Can I drive if I have an international/out of state license?',
    info: [
      {
        pretext:
          'To drive with Autzu, you must have a driver’s license registered with the state or province where you intend to drive. '
      },
      {
        posttext:
          'We recommend that you exchange your out-of-state or international license before registering for an account with us and creating your rideshare driver account.'
      }
    ]
  }
];

export default EligibilityFaqContentSF;



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/EligibilityFaqContentSF.js